<template>
  <div class="pair-up-over">
    <img
      class="star"
      src="@/assets/images/pair-up-over-star.png"
      alt=""
      draggable="false"
    >
    <h2>恭喜您！</h2>
    <p class="corp-count">
      您成功认识了<span class="number">{{ props.corpCount }}</span>家教育帮扶企业
    </p>
    <p class="bonus-count">
      获得<span class="number">{{ props.bonusCount }}</span>积分
    </p>
    <button
      class="replay"
      @click="emit('replay')"
    >
      <div class="highlight" />
      重新开始
    </button>
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted } from "vue"
import { useRoute, useRouter } from "vue-router"
import { useStore } from "vuex"

const route = useRoute()
const router = useRouter()
const store = useStore()

const {
  windowSizeInCssForRef,
  windowSizeWhenDesignForRef,
} = useSizeAdapt(390, 752)

const props = defineProps(['corpCount', 'bonusCount'])

const emit = defineEmits(['replay'])

</script>

<style lang="less" scoped>
.pair-up-over{
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  >img.star{
    position: absolute;
    left: 50%;
    top: calc(100 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
    transform: translate(-50%, 0);
    width: calc(300 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
  }
  >h2{
    position: absolute;
    left: 50%;
    top: calc(380 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
    transform: translate(-35%, 0);
    font-size: calc(40 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
    font-family: Source Han Sans SC, Source Han Sans SC;
    font-weight: bold;
    color: #FFFFFF;
    line-height: calc(47 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
  }
  >p.corp-count{
    position: absolute;
    left: 50%;
    top: calc(440 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
    transform: translate(-50%, 0);
    font-size: calc(16 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
    font-family: Source Han Sans SC, Source Han Sans SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: calc(19 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
    white-space: pre;
    >span.number{
      font-size: calc(24 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
      font-family: heiti;
      font-weight: bold;
      color: #EFB622;
      line-height: calc(28 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
      margin-left: 0.2em;
      margin-right: 0.2em;
    }
  }
  >p.bonus-count{
    position: absolute;
    left: 50%;
    top: calc(480 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
    transform: translate(-50%, 0);
    font-size: calc(16 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
    font-family: Source Han Sans SC, Source Han Sans SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: calc(19 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
    white-space: pre;
    >span.number{
      font-size: calc(24 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
      font-family: heiti;
      font-weight: bold;
      color: #EFB622;
      line-height: calc(28 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
      margin-left: 0.2em;
      margin-right: 0.2em;
    }
  }
  >button.replay{
    position: absolute;
    left: 50%;
    bottom: calc(52 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
    transform: translate(-50%, 0);
    width: calc(322 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
    height: calc(92 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
    background-image: url(@/assets/images/pair-up-btn-restart.png);
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
    font-size: calc(24 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
    font-family: Source Han Sans SC, Source Han Sans SC;
    font-weight: 800;
    color: #FFFFFF;
    line-height: calc(32 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
    // -webkit-text-stroke: calc(1 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef')) #4E3933;
    padding-bottom: calc(5 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
    >.highlight{
      position: absolute;
      top: calc(19 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
      left: calc(32 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
      width: calc(14 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
      height: calc(6 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
      border-radius: calc(3 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef'));
      background: #FFFFFF;
      filter: blur(calc(3 / v-bind('windowSizeWhenDesignForRef') * v-bind('windowSizeInCssForRef')));
      transform: rotateZ(-27deg);
    }
  }
}
</style>